export default __webpack_public_path__ + "static/media/Sonder_white_png.f8c27979.png";